/**
 * Data Transfer Object (DTO) for rate source.
 * Represents the wire format used by the backend API.
 */
export enum RateSourceDTO {
  FLAT = 'FLAT',
  USER = 'USER',
  SENIORITY = 'SENIORITY',
  ROLE = 'ROLE',
  PROJECT = 'PROJECT',
  ORGANIZATION = 'ORGANIZATION',
  RATE_CARD = 'RATE_CARD',
  CUSTOM = 'CUSTOM',
}

/**
 * Type alias for rate source in API requests.
 */
export type RateSourceRequest = RateSourceDTO;

/**
 * Type alias for rate source in API responses.
 */
export type RateSourceResponse = RateSourceDTO;

/**
 * Allowed rate source values for organization external rates configuration.
 * Limited to the 4 supported options per API contract.
 */
export type OrganizationRateSourceDTO =
  | RateSourceDTO.ORGANIZATION
  | RateSourceDTO.USER
  | RateSourceDTO.SENIORITY
  | RateSourceDTO.ROLE;
